import { EyeEmpty, ArrowRight } from 'iconoir-react';
import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../templates/Pagination'
import { convertFromPesewasToCedis } from '../../../utils';

const TransferTable = ({ transactions }) => {
  const navigator = useNavigate();
  const rowsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(transactions.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const getStatusBadge = (status) => {
    const styles = {
      'PENDING': 'badge-warning',
      'COMPLETED': 'badge-success',
      'REVERSED': 'badge-danger',
    };

    return (
      <span className={styles[status] || 'badge bg-slate-400 text-white'}>
        {status?.toLowerCase()}
      </span>
    );
  };

  return (
    <div className='card p-0 overflow-hidden'>
      <table className="table-modern">
        <thead>
          <tr>
            <th>Sender</th>
            <th></th>
            <th>Receiver</th>
            <th>Status</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {transactions && transactions.length > 0 ?
            transactions.slice(startIndex, endIndex).map((transaction, index) => (
              <tr key={transaction.id || index}>
                <td>
                  <div className="flex items-center gap-3">
                    <img
                      className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                      src={transaction.sender.profile_pic}
                      alt=""
                      loading="lazy"
                    />
                    <div>
                      <p className="font-semibold text-surface-800">
                        {transaction.sender.surname} {transaction.sender.other_names}
                      </p>
                      <p className="text-xs text-surface-400 capitalize">
                        {transaction.sender.role}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <ArrowRight strokeWidth={2} className='w-4 h-4 text-surface-400' />
                </td>
                {transaction.receiver ? (
                  <td>
                    <div className="flex items-center gap-3">
                      <img
                        className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                        src={transaction.receiver.profile_pic}
                        alt=""
                        loading="lazy"
                      />
                      <div>
                        <p className="font-semibold text-surface-800">
                          {transaction.receiver.surname} {transaction.receiver.other_names}
                        </p>
                        <p className="text-xs text-surface-400 capitalize">
                          {transaction.receiver.role}
                        </p>
                      </div>
                    </div>
                  </td>
                ) : (
                  <td>
                    <span className='text-surface-400 italic'>N/A</span>
                  </td>
                )}
                <td>
                  {getStatusBadge(transaction.transfer_status)}
                </td>
                <td>
                  <span className='font-semibold text-surface-800'>
                    GH₵ {convertFromPesewasToCedis(transaction.amount).toFixed(2)}
                  </span>
                </td>
                <td className='text-surface-500'>
                  {moment(transaction.createdAt).format('MMM D, YYYY h:mm A')}
                </td>
                <td>
                  <button
                    onClick={() => navigator(`/transactions/transfer/${transaction.id}`)}
                    className='btn-ghost p-2 rounded-lg'
                    title='View Details'
                  >
                    <EyeEmpty strokeWidth={2} className='w-4 h-4' />
                  </button>
                </td>
              </tr>
            )) :
            <tr>
              <td colSpan={7} className="text-center py-12">
                <p className='text-surface-400 italic'>No transactions available</p>
              </td>
            </tr>
          }
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className='border-t border-surface-100 px-6 py-4'>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      )}
    </div>
  )
}

export default TransferTable
